import { render } from "./TenantGroupList.vue?vue&type=template&id=096f03e1&scoped=true"
import script from "./TenantGroupList.vue?vue&type=script&lang=js"
export * from "./TenantGroupList.vue?vue&type=script&lang=js"

import "./TenantGroupList.vue?vue&type=style&index=0&id=096f03e1&scoped=true&lang=css"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096f03e1"]])

export default __exports__